import { Period, PeriodSelection } from '@pcplus/time-picker';
export class TimedRequest {
  constructor(
    public hours?: number | null,
    public fromDate?: Date | null,
    public toDate?: Date | null
  ) {}

  getPeriod() {
    if (!this.hours) {
      return PeriodSelection.Custom;
    }

    switch (this.hours) {
      case 1:
        return PeriodSelection.OneHour;
      case 6:
        return PeriodSelection.SixHours;
      case 24:
        return PeriodSelection.OneDay;
      case 24 * 7:
        return PeriodSelection.SevenDays;
      case 24 * 30:
        return PeriodSelection.ThirtyDays;
      case 24 * 365:
        return PeriodSelection.OneYear;
      case 24 * 365 * 3:
        return PeriodSelection.ThreeYears;
      case 24 * 365 * 5:
        return PeriodSelection.FiveYears;
      default:
        return PeriodSelection.Custom;
    }
  }

  getTime() {
    const result = new Period();
    result.period = this.getPeriod();
    if (result.period == PeriodSelection.Custom) {
      if (this.fromDate && this.toDate) {
        result.fromDate = this.fromDate;
        result.toDate = this.toDate;
      } else {
        result.period = PeriodSelection.OneHour;
      }
    }
    return result;
  }

  setTime(period: Period) {
    switch (period.period) {
      case PeriodSelection.OneHour:
        this.hours = 1;
        break;
      case PeriodSelection.SixHours:
        this.hours = 6;
        break;
      case PeriodSelection.OneDay:
        this.hours = 24;
        break;
      case PeriodSelection.SevenDays:
        this.hours = 24 * 7;
        break;
      case PeriodSelection.ThirtyDays:
        this.hours = 24 * 30;
        break;
      case PeriodSelection.OneYear:
        this.hours = 24 * 365;
        break;
      case PeriodSelection.ThreeYears:
        this.hours = 24 * 365 * 3;
        break;
      case PeriodSelection.FiveYears:
        this.hours = 24 * 365 * 5;
        break;
      case PeriodSelection.Custom:
        this.hours = null;
        this.fromDate = period.fromDate;
        this.toDate = period.toDate;
        break;
      case PeriodSelection.TwelveHours:
      default:
        this.hours = 12;
        break;
    }
  }
}
